"use client";

import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { getFriendlyErrorMessage } from "@/lib/error-messages";

interface GlobalErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// Next.js App Router root error boundary. Only triggers when an error occurs
// in the root layout itself, so it must render its own <html>/<body>. Shows a
// friendly message — never a stack trace or the error's digest/code.
export default function GlobalErrorPage({ error, reset }: GlobalErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-muted/40 px-4 text-center">
          <h1 className="text-3xl font-bold text-foreground">Something went wrong</h1>
          <p className="max-w-md text-muted-foreground">
            {getFriendlyErrorMessage(error, "We hit a snag loading the app. Please try again.")}
          </p>
          <Button onClick={() => reset()}>Try again</Button>
        </div>
      </body>
    </html>
  );
}
